import { createSlice } from '@reduxjs/toolkit';
import { LOGIN, LOGOUT } from '../../network/Endpoint';

export const voucherAuthSlice = createSlice({
  name: 'voucherAuth',
  initialState: {
    loginStatus: 'NOT_LOGGED_IN',
    account: {},
  },
  reducers: {
    init: (state) => {
      state.loginStatus = 'NOT_LOGGED_IN';
      state.account = {};
    },
    authLogin: (state, action) => {
      state.loginStatus = 'LOGGED_IN';
      state.account = action.payload.account;
    },
    authLogout: (state) => {
      state.loginStatus = 'NOT_LOGGED_IN';
      state.account = {};
    },
  },
});

export const initAsync = () => async (dispatch) => {
  try {
    dispatch(init());
  } catch (error) {
    throw new Error(error);
  }
};

export const authLoginAsync = (data) => async (dispatch) => {
  await LOGIN(data)
    .then(async (res) => {
      if (res.data.statusResponse.code === 'M0001') { // M0001: 성공
        dispatch(authLogin(res.data));
      } else if (res.data.statusResponse.code === 'M1001') { // M1001: 계정 없음
        alert('계정이 없어요. (Account not found.)');
      } else if (res.data.statusResponse.code === 'M1002') { // M1002: 비밀번호 틀림
        alert('비밀번호가 틀려요. (Wrong password.)');
      }
    })
    .catch((error) => {
      console.log('LOGIN error: ', error);
      alert('로그인을 실패했어요. (Login failed.)');
    });
};

export const authLogoutAsync = (data) => async (dispatch) => {
  await LOGOUT(data)
    .then(async (res) => {
      if (res.data.code === 'M0001') { // M0001: 성공
        dispatch(authLogout());
      }
    })
    .catch((error) => {
      console.log('LOGOUT error: ', error);
      alert('로그아웃을 실패했어요. (Logout failed.)');
    });
};

// Action creators are generated for each case reducer function
export const { init, authLogin, authLogout } = voucherAuthSlice.actions;
export default voucherAuthSlice.reducer;
